import React from "react";
import { useTranslation } from "react-i18next";
import SwiperCard from "./components/SwiperCard";
import Newsletter from "./components/Newsletter";

const AllBlogPosts = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="blogTitle">
        <h1>{t("blog_title")} <span>{t("blog_title_span")}</span></h1>
      </div>
      <SwiperCard />
      <Newsletter />
    </>
  );
};

export default React.memo(AllBlogPosts);
